// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

.main-content {
  flex: 1 1;
  transition: margin-left 0.3s ease, width 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content.sidebar-open {
  margin-left: 280px;
  width: calc(100% - 280px);
}

.main-content.sidebar-closed {
  margin-left: 70px;
  width: calc(100% - 70px);
}

.content {
  flex: 1 1;
  margin-top: 70px;
  padding: 0;
  overflow-y: auto;
  width: 100%;
}

/* Responsive */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":[".admin-layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f8fafc;\n}\n\n.main-content {\n  flex: 1;\n  transition: margin-left 0.3s ease, width 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.main-content.sidebar-open {\n  margin-left: 280px;\n  width: calc(100% - 280px);\n}\n\n.main-content.sidebar-closed {\n  margin-left: 70px;\n  width: calc(100% - 70px);\n}\n\n.content {\n  flex: 1;\n  margin-top: 70px;\n  padding: 0;\n  overflow-y: auto;\n  width: 100%;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
